import React from "react";
declare const __MEDIAX_BUILD__: {id:string;built_at:string};
export function MediaXBrand({light=false}:{light?:boolean}){
 const info=__MEDIAX_BUILD__;
 const date=new Intl.DateTimeFormat("cs-CZ",{timeZone:"Europe/Prague",day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}).format(new Date(info.built_at));
 return <span className="mediax-brand" aria-label="MediaX"><span className="mediax-wordmark">Media<img src={"/brand/xlab-beam-"+(light?"white":"black")+".png"} alt="X"/></span><small className="mediax-build" title={"Build "+info.id+" · "+info.built_at}>Build {info.id}<br/><time dateTime={info.built_at}>{date}</time></small></span>;
}
